import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { purchasesAPI } from '../../services/api';
import toast from 'react-hot-toast';

const fmt = (n) => Number(n || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
const statusMap = { draft: 'badge-gray', sent: 'badge-blue', partially_received: 'badge-orange', received: 'badge-green', cancelled: 'badge-red' };

export default function PurchaseOrderList() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await purchasesAPI.listOrders({ status, limit: 100 }); setOrders(r.data.orders); }
    catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [status]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div><h1>Purchase Orders</h1><p className="subtitle">{orders.length} orders</p></div>
        <div className="page-actions">
          <select className="form-select" style={{width:'auto'}} value={status} onChange={e => setStatus(e.target.value)}>
            <option value="">All Status</option><option value="draft">Draft</option><option value="sent">Sent</option>
            <option value="partially_received">Partially Received</option><option value="received">Received</option>
          </select>
          <Link to="/purchases/orders/new" className="btn btn-primary">+ New PO</Link>
        </div>
      </div>
      <div className="card"><div className="table-container">
        {loading ? <div className="loading-container"><div className="spinner" /></div> : (
          <table>
            <thead><tr><th>PO #</th><th>Supplier</th><th>Warehouse</th><th>Date</th><th>Expected</th><th style={{textAlign:'right'}}>Amount</th><th>Status</th></tr></thead>
            <tbody>
              {orders.map(po => (
                <tr key={po.id}>
                  <td className="td-mono font-semibold">{po.po_number}</td>
                  <td>{po.supplier_name}</td>
                  <td className="text-secondary">{po.warehouse_name || '-'}</td>
                  <td className="text-secondary">{new Date(po.po_date).toLocaleDateString('en-IN')}</td>
                  <td className="text-secondary">{po.expected_delivery ? new Date(po.expected_delivery).toLocaleDateString('en-IN') : '-'}</td>
                  <td className="td-amount font-bold">{fmt(po.total_amount)}</td>
                  <td><span className={`badge ${statusMap[po.status]}`}>{po.status?.replace('_',' ')}</span></td>
                </tr>
              ))}
              {orders.length === 0 && <tr><td colSpan={7} className="text-center text-secondary" style={{padding:40}}>No purchase orders</td></tr>}
            </tbody>
          </table>
        )}
      </div></div>
    </div>
  );
}
